import { Container } from '@material-ui/core'
import styled from 'styled-components'

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const Content = styled(Container)`
  max-width: 685px;
  padding-bottom: 40px;
`

export const Section = styled.div`
  padding-top: 20px;
`

export const SectionContent = styled.div`
  padding-top: 20px;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding-top: 20px;
  }
`

export const SectionParagraph = styled.div`
  padding-bottom: 20px;
`

export const VideoContainer = styled.div`
  text-align: center;
  position: relative;
  width: inherit;
`

export const CallToAction = styled.div`
  text-align: center;
`
